import React from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";

import Image from '../../../../containers/assets/pf7.png';

const ResearchAndInvestigateStep1 = () => (
  <OneVisualLayout
    section="RESEARCH & INVESTIGATE"
    title="Do Your Homework Before Next Round"
    paragraph1={(
      <Fragment>
        Before you commit to next round's decisions:
        <ul>
          <li>
            Open your Team Report. How did your results compare to the top
            teams? What did they do differently?
          </li>
          <li>
            Review the Customer Analysis. Have customer preferences shifted?
            What matters most to them now?
          </li>
          <li>
            Re-read the business case for details you skimmed the first time.
          </li>
          <li>
            Revisit the financial metrics and targets you need to hit next
            round.
          </li>
        </ul>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default ResearchAndInvestigateStep1;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/research-and-investigate/step1.js